import {
    request
} from "./request";

// find RegulatoryNetwork by Regulator
export function getAllRegulatoryNetwork() {
    return request({
        url: '/ascancer/api/regnet',
    })
}

export function getAllRegulator() {
    return request({
        url: '/ascancer/api/regnet/allreg',
    })
}